import type {PermissionType} from '@hconnect/apiclient'
import {useUpmPlantContext} from '@hconnect/upm'
import {useHasPermission} from '@hproduce/permissions'

export const usePermission = (type: PermissionType): boolean => {
  const {plantId, country: countryId} = useUpmPlantContext()
  const hasPermission = useHasPermission({plantId, countryId})
  return hasPermission(type)
}
